import React from 'react';
import ForgotPasswordForm from '../components/common/ForgotPasswordForm';

const ForgotPasswordPage = () => {
  return <ForgotPasswordForm />;
};

export default ForgotPasswordPage;